import { isZero } from './is-zero.js';

export const PERCENTAGE_MAX = 100;

export function percentage(
  current: number,
  total: number,
  { round = true }: PercentageOptions = {}
): number {
  if (isZero(total)) {
    return PERCENTAGE_MAX;
  }

  const value = (current / total) * PERCENTAGE_MAX;

  if (round) {
    return Math.min(Math.round(value), PERCENTAGE_MAX);
  }

  return Math.min(value, PERCENTAGE_MAX);
}

type PercentageOptions = {
  round?: boolean;
};
